import { render, staticRenderFns } from "./UserCreateFormStep3.vue?vue&type=template&id=aeb4a5d4&scoped=true"
import script from "./UserCreateFormStep3.vue?vue&type=script&lang=js"
export * from "./UserCreateFormStep3.vue?vue&type=script&lang=js"
import style0 from "./UserCreateFormStep3.vue?vue&type=style&index=0&id=aeb4a5d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb4a5d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aeb4a5d4')) {
      api.createRecord('aeb4a5d4', component.options)
    } else {
      api.reload('aeb4a5d4', component.options)
    }
    module.hot.accept("./UserCreateFormStep3.vue?vue&type=template&id=aeb4a5d4&scoped=true", function () {
      api.rerender('aeb4a5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/User/CreateForm/UserCreateFormStep3.vue"
export default component.exports